<template>
  <div class="content">
    <p class="header_title">智能路考仪学员协议</p>
    <p
      class="retract"
    >智能路考仪学员协议（以下简称“本协议”）是学员用户与车轮互联科技（上海）股份有限公司（以下简称“车轮”或“我们”）之间关于使用车轮智能路考仪设备（以下简称“设备”）及系统服务所共同订立的协议，对双方具有同等法律效力。</p>
    <p
      class="retract black"
    >为维护您的合法权益，我们建议您在使用前仔细阅读并充分理解本协议的全部内容，特别是以黑体加粗形式提示您注意涉及免除或者限制我们责任的条款。在确保您已经理解、接受本协议的前提下，购买培训课程并使用系统服务。您的购买及使用行为将视为同意接受本协议。</p>
    <p
      class="retract"
    >我们还需要提醒您的是，我们可以根据业务需求随时变更服务或更新本协议的条款，一旦本协议内容发生变更的，我们将通过在相关页面公示、发送站内信或其他合理方式进行通知，请您仔细阅读。如果您不同意变更的内容的，请停止使用设备及服务。如您继续使用的，则视为您已经同意变更的全部内容。</p>
    <p class="retract">如对本协议内容有任何疑问、意见、投诉或建议，您可通过联系在线客服联系我们。我们会尽快响应和处理您的请求。</p>
    <p class="title">一、定义</p>
    <p>
      1. 智能路考仪设备：指由车轮开发的搭载驾考科目AI智能评判系统并向教练和学员提供系统服务的硬件设备，适合在驾校培训车辆中使用。
      <br />2. 系统服务：指车轮依托驾考科目AI智能评判系统，以及超级教练平台和车轮平台（统称“平台”）现有业务，通过智能路考仪设备向教练向学员提供驾考模拟训练系统、仿真考试系统，记录并管理学员练车进度等的技术服务。
      <br />3. 教练：指具有驾校教练资格，激活并绑定智能路考仪设备，以及实际使用该设备提供的系统服务对其驾校学员进行培训并获取学员赞赏的自然人。教练与车轮之间无任何劳动关系或劳务关系，车轮不向教练支付任何劳动报酬。
      <br />4. 学员（或称为“用户”或“您”）：指使用智能路考仪设备并在平台注册为学员，购买培训课程并使用系统服务的自然人。
      <br />5. 学费：指学员在车轮平台购买相关培训课程并接受教练培训所支付的费用。
      <span class="black">学费包含车轮技术服务费及车轮代收代付给教练的赞赏费</span>，具体费用在学费中所占的比例以平台具体展示的情况为准。
    </p>
    <p class="title">二、用户注册</p>
    <p>
      1. 用户使用系统服务并购买相关培训课程，需要通过手机号码进行实名制注册，用户注册成功后，平台会为用户开通一个账户，作为用户使用系统服务的唯一身份标识。该账户及该账户产生的所有数据及信息的所有权均归属于车轮，用户在使用系统及平台服务期间拥有使用权。
      <br />2. 用户注册平台账号的，还需遵守相关平台规则（包括但不限于用户协议、隐私政策），上述平台规则构成本协议不可分割的一部分。
      <br />3. 用户理解并同意，车轮通过向用户注册时预留的地址、电话、邮箱等任一方式发送信息，或者通过平台发送站内信息，即视为车轮向用户履行了送达、通知义务。
    </p>
    <p class="title">三、费用</p>
    <p>
      1. 车轮向用户提供系统服务并收取技术服务费。具体收费方式为：
      <span
        class="black"
      >学员登录平台购买相关培训课程并支付学费，学费包含车轮技术服务费及车轮代收代付给教练的赞赏费</span>。车轮根据平台具体展示的比例在学费中扣收技术服务费，并按照法律法规规定将学员代收代付的赞赏费转至教练在车轮平台的账户内。教练选择提现的，车轮将费用支付至教练实名认证的收款账户。
      <br />2. 学员学费根据学员购买的培训课程等不同而不同，具体以购买时平台提供的价格为准。
      <br />
      <span class="black">
        3. 技术服务费采用先收费后服务的方式，支付成功后不可退款（如因服务存在重大瑕疵导致完全无法使用等平台违约的情形、本协议另有约定、法律法规要求必须退款的或经车轮判断后认为可以退款的除外）。
        <br />4. 如因学员与教练发生争议导致学员要求退款的，由于平台已将费用支付给教练，因此学员与教练应自行协商解决。车轮可为争议解决提供力所能及的帮助，但不为任何一方承担损失赔偿责任。
      </span>
      <br />5. 用户对相关费用有异议的，可及时向平台提供的渠道进行反应，车轮将尽快核实并解决。
    </p>
    <p class="title">四、服务使用规则</p>
    <p>
      1. 用户承诺拥有完全民事权利能力和民事行为能力签署并履行本协议，用户实名认证信息真实有效，且签署并履行本协议不违反任何对您有约束力的第三方协议或其它适用法律的限制，也不会侵犯本协议以外任何第三方之合法权益。您从事的任何活动合法、服务项目用途合法、所发布之信息内容不会损害平台、车轮及关联公司的利益、商誉和品牌形象。
      <br />
      <span class="black">
        2. 车轮为开发智能路考仪设备及系统花费了大量的人力、物力成本，并以提供系统服务为最终目的。用户等一切人员和组织应仅以使用系统服务为目的使用设备，不得以非法占有设备、违规使用系统服务等为目的对设备/系统实施包括但不限于以下非法行为：
        <br />（1） 故意关闭/屏蔽设备联网功能，屏蔽车轮对设备的使用状态监控的；
        <br />（2） 未经车轮书面同意，在设备中安装除车轮以外的任何第三方提供的软件/服务的；
        <br />（3） 恶意使用设备及系统，使用装置、软件或例行程序干预或试图干预系统；
        <br />（4） 利用计算机病毒/程序等手段，非法窃取、删除、修改或增加其他任何信息，或以其他任何方式危害设备系统其他功能的正常运行；
        <br />（5） 利用平台系统漏洞，谋取利益；
        <br />（6） 以不良方法或技术等规避本协议约定的；
        <br />（7） 未经车轮书面同意，以任何手段获取设备组件或/和系统中的数据信息的；
        <br />（8） 未经车轮书面同意，出租、转租、出售、对外提供设备的；
        <br />（9） 故意损坏设备的。
        <br />车轮一旦发现上述情况，将追究激活并绑定设备的教练的法律责任，除非该教练能够提供证据表明上述行为是由第三方实施的。同时，车轮鼓励任何用户向车轮举报上述非法行为，举报方式为：lk-service@chelun.com，车轮将视情况向举报人提供一定的优惠或奖励。
        <br />
        <span
          class="black"
        >3. 车轮为用户提供系统服务，鉴于平台具备存在海量信息及信息网络环境下信息与实物相分离的特点，车轮只能从形式上审核用户资质并根据平台协议有限地监管相关用户行为的合法性、交易或服务的真实性或准确性。对此，您应谨慎判断与其他用户交易的安全性（包括学员借助平台购买教练培训课程的情况），并根据约定各自向对方承担责任，除法律法规规定的情况外，车轮对此不承担任何责任。</span>
      </span>
      <br />4. 您须根据本协议及平台规则使用设备及系统服务，并遵守国家法律法规（包括但不限于《广告法》、《互联广告管理暂行办法》等）规定编辑、发布、修改、更新推广信息，并对所发布信息及基于信息与用户间达成交易的真实性、有效性、准确性、合法性（包括但不限于《消费者权益保护法》、《产品质量法》、《广告法》等）、不侵犯第三方合法权利（包括但不限于知识产权、隐私权、肖像权等人身权利及或其他合法权利）独立承担全部法律责任。如您的推广内容、信息或页面中通过设置链接或跳转方式可链接至其他网站，则您承诺该网站内容合法、有效。您应积极妥善解决与本平台其他用户间开展交易过程中产生的全部争议、纠纷、索赔、仲裁、诉讼等。
      <br />5. 您在使用系统服务的过程中，应当：
      <br />（1） 妥善保管您的账号和密码，并采取必要和有效的保密措施。非本平台法定过错导致的任何遗失、泄露、被篡改、被盗以及其他因保管、使用、维护不当而造成的损失，您应自行承担。
      <br />（2） 遵守有关法律法规，遵守公共秩序，尊重社会公德，不危害网络安全，传播暴力、淫秽色情信息，编造、传播虚假信息扰乱经济秩序和社会秩序，以及从事侵害他人名誉、隐私、知识产权和其他合法权益等活动。
      <br />（3） 您不得自行（或协助他人）通过以下方式获取与使用系统服务：
      <br />① 通过机器人软件、蜘蛛软件、爬虫软件等任何自动程序、脚本、软件等方式；
      <br />② 未经本平台允许通过转移、赠与、借用、租用、销售、转让账号的方式；
      <br />③ 通过不正当手段或以违反诚实信用原则的方式（如利用规则漏洞、利用系统漏洞、滥用用户身份、黑色产业、投机等）；
      <br />④ 通过利用或破坏本协议及相关服务规则的方式。
      <br />6. 您需对自己在使用设备及系统服务过程中的行为承担法律责任。若用户的行为违反上述承诺条款的，本平台将有权作出独立判断采取相应措施，包括但不限于直接屏蔽、删除违法侵权信息、降低用户信用值，或直接停止提供服务、收回设备、追究用户的法律责任等。
    </p>
    <p class="title">五、知识产权和数据权利</p>
    <p>除法律法规规定或协议另有约定的外，智能路考仪设备及平台所有内容、系统、数据信息由车轮或其关联公司享有全部知识产权和数据权利。</p>
    <p class="title">六、违约责任</p>
    <p>
      1. 对于用户涉嫌违反承诺的行为对第三方造成损害的，用户均应当以自己的名义独立承担所有的法律责任，并应确保本平台免于承担因此产生的损失或增加的费用。
      <br />2. 如用户涉嫌违反有关法律或者本协议之规定，使本平台遭受任何损失，或受到任何第三方索赔，或受到任何行政管理部门处罚的，用户应当赔偿本平台因此造成的损失及（或）发生的费用，包括但不限于赔偿金、违约金、和解费、诉讼费用、律师费、差旅费等。
      <br />
      <span class="black">
        3. 车轮依照法律规定履行基础保障义务，但对于下述原因导致的协议履行障碍、履行瑕疵、履行延后或履行内容变更等情形，车轮并不承担相应的违约责任：
        <br />（1） 因自然灾害、罢工、暴乱、战争、政府行为、司法行政命令等不可抗力因素；
        <br />（2） 因电力供应故障、通讯网络故障等公共服务因素或第三人因素；
        <br />（3） 在车轮已尽善意管理的情况下，因常规或紧急的设备与系统维护、设备与系统故障、网络信息与数据安全等因素。
      </span>
    </p>
    <p class="title">七、法律适用和争议解决</p>
    <p>
      1. 本协议之订立、生效、解释、修订、补充、终止、执行和争议解决均适用中华人民共和国法律。如法律无相关规定的，则应参照通用商业惯例和（或）行业惯例。
      <br />2. 因本协议产生之争议、纠纷，应由本平台与用户友好协商；协商不成的，应向上海市浦东新区人民法院提起诉讼解决。
      <br />3. 本协议的标题仅为方便及阅读而设，并不影响正文中任何条款的含义或解释。
    </p>
  </div>
</template>
<script>
export default {
  data() {
    return {
      advise: []
    };
  },
  methods: {},
  mounted() {
    let remark = sessionStorage.remark;
    if (remark) {
      this.remark = remark;
    }
  }
};
</script>
<style lang="scss" scoped>
.content {
  font-size: 0.28rem;
  padding: 0.1rem 0.16rem 0.5rem;
  color: #333;
  .header_title {
    font-size: 0.34rem;
    font-weight: 500;
    text-align: center;
    padding-top: 0.1rem;
    padding-bottom: 0.3rem;
  }
  .retract {
    text-indent: 0.56rem;
  }
  .black,
  .title {
    color: #000;
    font-weight: 500;
  }
  .title {
    padding-top: 0.28rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/advise/advise.vue